<button [type]="type" class="pds-button --{{ modifier }}" [disabled]="disabled">
  <ng-container *ngIf="icon">
    <span class="material-symbols-outlined">{{ icon }}</span>
  </ng-container>
  <span class="pds-button__label">
    <ng-content></ng-content>
  </span>
</button>
